/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-no-constructed-context-values */
/* eslint-disable react/prop-types */
import React from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import request from '@api';
import FullpageLoading from '@components/FullpageLoading';
import queryString from 'query-string';

const Context = React.createContext();

export function AuthProvider({ children }) {
  const [data, setData] = React.useState(null);

  const updateUser = async () => {
    try {
      const { mockToken } = queryString.parse(window.location.search);
      const res = await request(mockToken ? `user-status?mockToken=${mockToken}` : 'user-status');
      const {
        code,
        data: {
          login, onBoardingProcess, registerEmail, payment, merchantName,
        },
      } = res;
      if (code === 0) {
        setData({
          login, merchantName, stage: onBoardingProcess, email: registerEmail, payment,
        });
      }
    } catch (e) {
      console.log(e);
    }
  };

  React.useLayoutEffect(() => {
    updateUser();
  }, []);

  // avoid page flicker
  if (data === null) {
    return (
      <FullpageLoading />
    );
  }

  const signout = async (callback) => {
    await request('logout', { method: 'POST', mode: 'no-cors' }).catch(console.log);
    if (typeof callback === 'function') {
      callback();
    }
    setData({});
  };

  const { login, merchantName, ...onboarding } = data;
  const value = {
    login, merchantName, onboarding, updateUser, signout,
  };
  return <Context.Provider value={value}>{children}</Context.Provider>;
}

export function useAuthContext() {
  return React.useContext(Context);
}

export function RouterControl({ children }) {
  const data = useAuthContext();
  const location = useLocation();
  const { login, onboarding } = data || {};
  const { stage } = onboarding || {};
  if (!login) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  const navigationMap = {
    registered: '/onboarding/connect',
    store_connected: '/onboarding/survey',
    // questionnaire_completed: '/onboarding/select',
  };
  const { pathname } = location;
  if (navigationMap[stage] && pathname !== navigationMap[stage]) {
    return <Navigate to={navigationMap[stage]} state={{ from: location }} replace />;
  }

  return children;
}

export function AuthControl({ children }) {
  const data = useAuthContext();
  const location = useLocation();
  const { login } = data || {};
  if (!login) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}
